import store from '@/store'
import { Station } from '@/api/dtos/Station.schema'
import { StationSummary } from '@/api/dtos/StationSummary.schema'
import * as stationsApi from '@/api/stations'
import {
  Module,
  VuexModule,
  MutationAction,
  Mutation,
  getModule
} from 'vuex-module-decorators'

export interface IStationStoreState {
  detailedStation: Station | null;
  stationSummaries: StationSummary[];
  operatorStations: StationSummary[];
}

@Module({ dynamic: true, store, name: 'stations' })
class Stations extends VuexModule implements IStationStoreState {
  public detailedStation: Station | null = null;
  public stationSummaries: StationSummary[] = [];
  public operatorStations: StationSummary[] = [];

  @Mutation
  public CLEAR_OPERATOR_STATIONS(): void {
    this.operatorStations = [];
  }

  @MutationAction({ mutate: ['stationSummaries'] })
  public async fetchStationSummaries (): Promise<{
    stationSummaries: StationSummary[];
  }> {
    return {
      stationSummaries: await stationsApi.getStations()
    }
  }

  @MutationAction({ mutate: ['operatorStations'] })
  public async fetchStationSummariesForOperator (operatorId: string): Promise<{
    operatorStations: StationSummary[];
  }> {
    return {
      operatorStations: await stationsApi.getStationsByOperator(operatorId)
    }
  }

  @MutationAction({ mutate: ['detailedStation'] })
  public async fetchDetailedStation (
    stationId: string
  ): Promise<{ detailedStation: Station }> {
    return {
      detailedStation: await stationsApi.getStation(stationId)
    }
  }

  @MutationAction({ mutate: ['detailedStation'] })
  public async refreshDetailedStation (): Promise<{ detailedStation: Station }> {
    if (!this.detailedStation) {
      throw Error('no detailed station to refresh present!')
    }
    return {
      detailedStation: await stationsApi.getStation(this.detailedStation.uuid)
    }
  }
}

export const StationsModule = getModule(Stations)
